<div (click)="setSelected(r)" *ngFor="let r of data" class="d-flex" style="border-radius: 10px;background-color:{{myColor1}}; width: 100%; height: 6rem; cursor: pointer;">

    <div class="w-75 text-start p-1" style="height: 6rem;">
        <h6><strong> <i class="fa fa-bulb"></i> {{r['name']}}</strong></h6>
        <p *ngIf="r['contents'][0]['message'].length >50 ">{{ r['contents'][0]['message'] | slice:0:50}}...</p>
        <p *ngIf="r['contents'][0]['message'].length <= 50">{{r['contents'][0]['message']}}</p>
    </div>
    <div class="w-25 pt-2">
            <span class="p-1 rounded" style="background-color:{{myColor2}}; ">{{r['contents'].length}}</span>
    </div>
</div>